import { connect } from 'react-redux';
import { grabMobileUserID, fetchUsername, clearUsernameData, fetchMobileUsers } from '../../actions/settings_actions';
import { setDefaultOfForm } from '../../actions/purchaseOrders_actions';
import MobileUserTable from '../../components/Settings/MobileUserTable';

function mapStateToProps(state) {
  return {
    mobileUserId: state.settings.mobileUserId,
    username: state.settings.username,
    usernameIsLoading: state.settings.usernameIsLoading,
    userNameError: state.settings.userNameError,
  };
}

export default connect(mapStateToProps, {
  grabMobileUserID,
  fetchUsername,
  clearUsernameData,
  setDefaultOfForm,
  fetchMobileUsers,
})(MobileUserTable);


// WEBPACK FOOTER //
// ./master/jsx/containers/Settings/mobileUserTable.jsx